import {FormattedMessage} from "react-intl";
import React from "react";
import Currency from "../../../Currency/Currency";
import usePreSubmitParlayService from "../../../../services/hooks/usePreSubmitParlayService";

const CreateFromPreSelectedParlayFooter = ({parlay, contests}) => {
    const {submitParlay, disableSubmitParlay} = usePreSubmitParlayService({parlay, contests});

    const handleSubmitPicksClick = async () => {
        await submitParlay();
    };

    return (
        <div className={"CreateFromPreSelectedParlayFooter"}>
            <div className={"fee"}>
                <FormattedMessage id={'lobbyView.betSlip.betSlip.entryFee'}/>
                : <Currency value={parlay.Wager} currency={parlay.WagerCurrency} removeDecimal/>
            </div>
            <button className={`submitButton ${disableSubmitParlay ? "disabled" : ""}`}
                    disabled={disableSubmitParlay}
                    onClick={handleSubmitPicksClick}>
                <FormattedMessage id={'lobbyView.betSlip.betSlip.submitPicks'}/>
            </button>
        </div>
    );
};

export default CreateFromPreSelectedParlayFooter;
